/**
 * @fileoverview Report generation and analytics actions
 * @module ReportActions
 */

import apiClient from "../utils/apiClient";
/**
 * Obtains reports according to specified date parameters
 * @function
 * @name getReports
 * @memberof module:ReportActions
 * @param {Object} params - Parameters for the report
 * @param {string} params.typeReport - Type of report to generate
 * @param {string|Array} [params.operation_type] - Operation type filter
 * @param {string|Array} [params.status_property] - Property status filter
 * @returns {Promise<Object|undefined>} Report data according to the selected dates
 */
export const getReports = async (params) => {
  if (params.operation_type) {
    params.operation_type = params.operation_type.toString();
  } else if (params.status_property) {
    params.status_property = params.status_property.toString();
  }
  try {
    const response = await apiClient.get(`/reports/${params.typeReport}`, {
      params,
    });
    return response;
  } catch (err) {
    $log.error(err);
  }
};
